import { DollarSign } from 'lucide-react';
import { formatTripRevenue } from '../utils/tripRevenue';

/**
 * Revenue display.
 * `header` is the second row under the driver LM / DH / Away / Total box.
 * `card` sits inline on the trip card, after miles.
 */
export default function TripRevenueLabel({
  value,
  variant = 'card',
  textClassName = 'leading-none',
  middleLabel = '',
  middleValue = '—',
  tripCount = 0,
}) {
  const amount = formatTripRevenue(value);
  if (variant === 'header') {
    const tripsTitle = Number(tripCount) === 1 ? '1 trip' : `${tripCount} trips`;
    const showMiddle = Boolean(middleLabel);
    return (
      <div className={`grid items-center border-t border-white/10 py-1 ${showMiddle ? 'grid-cols-3' : 'grid-cols-2'}`}>
        <div className="flex items-baseline justify-center gap-0.5 whitespace-nowrap border-r border-white/5 px-1" title={`Revenue: ${amount}`}>
          <span className="text-[7px] font-black uppercase leading-none tracking-tighter opacity-60">Rev:</span>
          <span className="text-[10px] font-black leading-none tabular-nums">{amount}</span>
        </div>
        {showMiddle ? (
          <div className="flex min-w-0 items-baseline justify-center gap-0.5 whitespace-nowrap border-r border-white/5 px-1" title={`${middleLabel}: ${middleValue}`}>
            <span className="text-[7px] font-black uppercase leading-none tracking-tighter opacity-60">{middleLabel}:</span>
            <span className="min-w-0 truncate text-[10px] font-black leading-none tabular-nums">{middleValue}</span>
          </div>
        ) : null}
        <div className="flex items-baseline justify-center gap-0.5 whitespace-nowrap px-1" title={tripsTitle}>
          <span className="text-[7px] font-black uppercase leading-none tracking-tighter opacity-60">Trips:</span>
          <span className="text-[10px] font-black leading-none tabular-nums">{tripCount}</span>
        </div>
      </div>
    );
  }
  return (
    <div className="flex min-w-0 items-center gap-x-1.5" title={`Revenue: ${amount}`}>
      <DollarSign className="h-4 w-4 shrink-0 text-main-light" strokeWidth={2} aria-hidden />
      <div className={`min-w-0 truncate text-main-light ${textClassName}`}>{amount}</div>
    </div>
  );
}
